import * as Sentry from '@sentry/nextjs'

export function onImageError(event: React.SyntheticEvent<HTMLImageElement, Event>) {
	Sentry.captureException(new Error(`Image load error: ${event.currentTarget.src}`))
}
